import Home from 'containers/Home';
import { HOMEPAGE_ARTICLES_LIMIT, PAGES } from 'utils/constants';
import { wrapper } from 'redux/store';
import pageApi from 'redux/apis/page';
import blogApi from 'redux/apis/blog';
import { rootUrl } from 'utils/helper';
import { handleError } from 'utils/error';

// export const getStaticProps = getStaticPropsWrapper(PAGES.homepage, getHomePageDataPros);

export const getStaticProps = wrapper.getStaticProps((store) => async () => {
  try {
    const blogQuery = { limit: HOMEPAGE_ARTICLES_LIMIT };
    const actions = [];

    const state = store.getState();

    actions.push(
      store.dispatch(pageApi.endpoints.fetchPage.initiate(PAGES.homepage)),
      store.dispatch(blogApi.endpoints.getArticlesList.initiate(blogQuery)),
    );

    await Promise.all(actions);

    const { data } = pageApi.endpoints.fetchPage.select(PAGES.homepage)(store.getState());

    const pageMetadata = {
      ...data.metaData,
      url: `${rootUrl}`,
    };

    const components = data.contentModules;

    const props = {
      pageFetchQuery: PAGES.homepage,
      pageData: components,
      pageMetadata,
      blogQuery,
      type: PAGES.homepage,
    };

    return {
      props,
      revalidate: 86400,
    };
  } catch (error) {
    handleError({
      error,
      message: 'Error in the Homepage.getStaticProps function',
    });

    return { notFound: true };
  }
});

export default Home;
